import { useEffect } from 'react';
import { hasPermission } from '@lognai/plugin-sdk';
import { apiFetch } from '../api/client';
import { invalidateAnalyticsBootstrap } from './api';
export const DATASET_CHANGED = 'analytics:datasets:changed';
export function useDatasetRefresh() {
  useEffect(() => {
    if (!hasPermission('analytics:datasets:read')) return;
    let live = true,
      busy = false,
      previous: string | undefined;
    const poll = async () => {
      if (busy || document.visibilityState === 'hidden') return;
      busy = true;
      try {
        const result = await apiFetch<{ revision: string }>('/api/analytics/datasets/revision');
        if (!live) return;
        if (previous && previous !== result.revision) {
          invalidateAnalyticsBootstrap();
          window.dispatchEvent(new Event(DATASET_CHANGED));
        }
        previous = result.revision;
      } catch {
        /* Existing data remains available during a temporary polling failure. */
      } finally {
        busy = false;
      }
    };
    void poll();
    const timer = setInterval(() => void poll(), 15000);
    return () => {
      live = false;
      clearInterval(timer);
    };
  }, []);
}
